(function(){
  async function mcsAdd(btn){
    var id=btn.getAttribute('data-mcs-add'); if(!id) return;
    var label=btn.innerHTML; btn.disabled=true; btn.innerHTML='Adding…';
    var drawer=document.querySelector('cart-drawer');
    var body={items:[{id:Number(id),quantity:1}]};
    if(drawer){body.sections='cart-drawer,cart-icon-bubble';body.sections_url=window.location.pathname;}
    try{
      var r=await fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});
      var data=await r.json();
      if(!r.ok) throw new Error(data.description||'Error');
      if(drawer&&data.sections){try{drawer.classList.remove('is-empty');drawer.renderContents(data);}catch(e){window.location.href='/cart';return;}}
      else{window.location.href='/cart';return;}
      btn.innerHTML='Added ✓';
      setTimeout(function(){btn.innerHTML=label;btn.disabled=false;},1800);
    }catch(e){btn.innerHTML='Sold out – try another';setTimeout(function(){btn.innerHTML=label;btn.disabled=false;},2200);}
  }
  document.addEventListener('click',function(e){var b=e.target.closest('[data-mcs-add]');if(b){e.preventDefault();mcsAdd(b);}});
  // sticky add-to-cart on product page
  document.addEventListener('DOMContentLoaded',function(){
    var bar=document.querySelector('.mcs-sticky'); if(!bar) return;
    var main=document.querySelector('.product-form__submit'); if(!main) return;
    document.body.classList.add('mcs-has-mbar');
    var io=new IntersectionObserver(function(en){bar.classList.toggle('is-on',!en[0].isIntersecting&&en[0].boundingClientRect.top<0);});
    io.observe(main);
    var sbtn=bar.querySelector('[data-mcs-sticky]');
    if(sbtn) sbtn.addEventListener('click',function(){main.click();});
  });
  if(document.querySelector('.mcs-mbar')) document.addEventListener('DOMContentLoaded',function(){document.body.classList.add('mcs-has-mbar');});
})();
